import { useEffect, useState, useCallback } from 'react'
import isClient from '@mobi/utils/browser/isClient'

const useMediaQuery = (size) => {
  const [matches, setMatches] = useState(false)

  const sizes = {
    mobile: '(max-width: 699px)',
    notMobile: '(min-width: 700px)',
    tablet: '(max-width: 1024px)',
    desktop: '(min-width: 1025px)',
  }

  const query = sizes[size]

  const updateMedia = useCallback(() => {
    if (isClient()) {
      const onResize = () => setMatches(window.matchMedia(query).matches)
      setMatches(window.matchMedia(query).matches)
      window.addEventListener('resize', onResize)
      return () => {
        window.removeEventListener('resize', onResize)
      }
    }
  }, [query, matches])

  useEffect(() => {
    updateMedia()
  }, [])

  return matches
}

export default useMediaQuery
